import { render, staticRenderFns } from "./znxq2.vue?vue&type=template&id=4c949418&scoped=true&"
import script from "./znxq2.vue?vue&type=script&lang=js&"
export * from "./znxq2.vue?vue&type=script&lang=js&"
import style0 from "./znxq2.vue?vue&type=style&index=0&id=4c949418&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c949418",
  null
  
)

export default component.exports